import React from "react";
import { Typography, Grid } from "@material-ui/core";
import DPCard from "Components/DP/DPCard/DPCard";
import useStyles from "./styles";
import SkeletonMetricBox from "./SkeletonMetricBox";

export interface IMetricBox {
  title: string;
  value: JSX.Element | string;
  valueSuffix: string;
  footer: string;
  loading?: boolean;
}

export const MetricBox = ({
  title,
  value,
  valueSuffix,
  footer,
  loading,
}: IMetricBox) => {
  const classes = useStyles();

  if (loading) {
    return <SkeletonMetricBox />;
  }

  return (
    <Grid className={classes.gridWrapper} item>
      <DPCard classOverrides={classes.card}>
        <Grid container direction={"column"} spacing={1}>
          <Grid item>
            <Typography gutterBottom className={classes.title}>
              {title}
            </Typography>
          </Grid>
          <Grid alignItems="baseline" container item wrap="nowrap">
            <Typography component={"span"} className={classes.value}>
              {value}
            </Typography>
            <Typography component={"span"} className={classes.valueSuffix}>
              {valueSuffix}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.footer}>{footer}</Typography>
          </Grid>
        </Grid>
      </DPCard>
    </Grid>
  );
};
